import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { maxBirthDate, minBirthDate } from "../../helpers/date_helpers";
import ar from "date-fns/locale/ar";
import i18n from "../../i18n";
registerLocale("ar", ar);

type AppDatePickerProps = {
  label?: string;
  placeholder: string;
  error?: string | undefined | null;
  selected?: Date;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  required?: boolean;
};

export default function AppDatePicker(props: AppDatePickerProps) {
  const {
    label,
    placeholder,
    error,
    selected,
    onChange,
    minDate,
    maxDate,
    required,
  } = props;
  const minimumDate = minDate || minBirthDate().toDate();
  const maximumDate = maxDate || maxBirthDate().toDate();

  return (
    <>
      {label && (
        <label
          htmlFor={placeholder}
          className={"block text-sm font-medium text-gray-700 mb-1"}
        >
          {`${label}${!!required ? "*" : ""}`}
        </label>
      )}
      <DatePicker
        id={placeholder}
        required={!!required}
        placeholderText={placeholder}
        showYearDropdown
        showMonthDropdown
        dropdownMode="select"
        selected={selected}
        onChange={onChange}
        maxDate={maximumDate}
        minDate={minimumDate}
        dateFormat={"dd/MM/yyyy"}
        dateFormatCalendar={"dd/MM/yyyy"}
        locale={i18n.language}
        autoComplete={"off"}
      />
      {!!error && <div className="mt-2 text-sm text-red-600">{error}</div>}
    </>
  );
}
